<template>
    <div class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50" :class="busy && 'disabled'">
        <div class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
            <QrIcon icon="images" class="h-6 w-6 text-gray-600 group-hover:text-brand" aria-hidden="true" />
        </div>
        <div>
            <button @click="create" class="font-semibold text-gray-900">
                {{ trans('homepage.gallery') }}
                <span class="absolute inset-0" />
            </button>
            <p class="mt-1 text-gray-600" v-text="trans('homepage.gallery_desc')"/>
        </div>
    </div>
</template>

<script setup>
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import { trans } from "@/libs/helper.js";
import { useQrCodeHomepageStore } from "@/store/qrCodeHomepage.js";
import emitter from "@/libs/emitter.js";
import { ref } from 'vue';

const props = defineProps({
    homepageContent: Object,
});

const emit = defineEmits(['close']);
const homepageStore = useQrCodeHomepageStore();
const busy = ref(false);

const create = async () => {
    if (busy.value) {
        return;
    }

    busy.value = true;
    const data = await homepageStore.create({
        type: 'images',
        menu_button_name: trans('homepage.gallery'),
        is_password_protected: false,
        password: '',
        content: { autoplay: false, loop: false },
    });

    busy.value = false;
    emitter.emit('created-gallery', data.id);
    emit('close');
};

</script>
